import { Field, Input } from "../../components/ui/Field";

/** The inputs every auth form shares, with the right autocomplete hints for password managers. */
export function EmailField({ value, onChange, autoFocus }: { value: string; onChange: (v: string) => void; autoFocus?: boolean }) {
  return (
    <Field label="email">
      {({ id }) => (
        <Input id={id} type="email" required autoComplete="email" placeholder="you@example.com" value={value}
          onChange={(e) => onChange(e.target.value)} autoFocus={autoFocus} />
      )}
    </Field>
  );
}

export function PasswordField({ value, onChange, isNew, label = "password" }: { value: string; onChange: (v: string) => void; isNew?: boolean; label?: string }) {
  return (
    <Field label={label} hint={isNew ? "At least 10 characters." : undefined}>
      {({ id, describedBy }) => (
        <Input id={id} type="password" required minLength={10} maxLength={128} aria-describedby={describedBy}
          autoComplete={isNew ? "new-password" : "current-password"} value={value} onChange={(e) => onChange(e.target.value)} />
      )}
    </Field>
  );
}

/**
 * `accountExists` only where the account is certain (verifying a new sign-up). Elsewhere the hint must not confirm
 * that the email is registered, because no code is sent to an unknown email.
 */
export function CodeField({ value, onChange, email, accountExists = false }: { value: string; onChange: (v: string) => void; email: string; accountExists?: boolean }) {
  const sent = accountExists
    ? <>We emailed it to <strong>{email}</strong>.</>
    : <>If there's an account for <strong>{email}</strong>, we've emailed it a code.</>;
  return (
    <Field label="6-digit code" hint={<>{sent} It works for 10 minutes.</>}>
      {({ id, describedBy }) => (
        <Input id={id} required inputMode="numeric" autoComplete="one-time-code" pattern="\d{6}" maxLength={6} autoFocus
          aria-describedby={describedBy} className="text-2xl tracking-[0.5em]" value={value}
          onChange={(e) => onChange(e.target.value.replace(/\D/g, "").slice(0, 6))} />
      )}
    </Field>
  );
}
